import React, { useState } from 'react';
import axios from 'axios';

function LoginPage({ apiUrl, onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) { setError('Veuillez remplir tous les champs'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${apiUrl}/auth/login`, { username, password, source: 'webapp' });
      onLogin(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleLogin}>
        <div style={{ fontSize: '56px' }}>🏖️</div>
        <h1>Gestion de Plage</h1>
        <p>Connectez-vous pour accéder au tableau de bord</p>
        {error && <div className="error-msg">{error}</div>}
        <div className="form-group">
          <label>Nom d'utilisateur</label>
          <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Entrez votre nom" autoFocus />
        </div>
        <div className="form-group">
          <label>Mot de passe</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Mot de passe" />
        </div>
        <button className="btn btn-primary" type="submit" style={{ width: '100%', padding: '12px', fontSize: '16px', marginTop: '8px' }} disabled={loading}>
          {loading ? 'Connexion...' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}

export default LoginPage;
